import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/h58wUekQZycBGPqmB5effo/682effc0ba43af376950f23b_renders_robeta.jpg';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex items-end pb-24 md:pb-32 overflow-hidden" data-id="element-227">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-228">
        <img src={HERO_IMAGE_URL} alt="Robeta Camper Van in Nature" className="w-full h-full object-cover" data-id="element-229" />
        {/* Overlays for text readability */}
        <div className="absolute inset-0 bg-black/20" data-id="element-230" />
        <div className="absolute top-0 right-0 w-2/3 h-full bg-gradient-to-l from-black/40 to-transparent" data-id="element-231" />
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-232" />
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 60
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-5xl" data-id="element-234">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white uppercase tracking-editorial leading-[0.9] mb-8" data-id="element-235">
            European Luxury.
            <br data-id="element-236" />
            <span className="text-white/90" data-id="element-237">North American Adventure.</span>
          </h1>

          <p className="text-base md:text-xl font-light text-white/80 max-w-xl mb-12 leading-relaxed" data-id="element-238">
            Discover Class B camper vans designed without compromise. Precision
            engineered in Slovenia, now available in Canada.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-6" data-id="element-239">
            <Link to="/models" className="px-10 py-4 bg-white text-robeta-black font-bold uppercase tracking-widest hover:bg-robeta-mist transition-colors min-w-[200px] text-center" data-id="element-240">
              Explore Models
            </Link>
            <Link to="/dealer-network" className="px-10 py-4 border border-white text-white font-bold uppercase tracking-widest hover:bg-white/10 transition-colors min-w-[200px] text-center" data-id="element-241">
              Find a Dealer
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 flex flex-col items-center gap-2" data-id="element-242">
        <span className="text-[10px] uppercase tracking-widest" data-id="element-243">Scroll</span>
        <ChevronDown className="w-4 h-4 animate-bounce" data-id="element-244" />
      </motion.div>
    </section>;
}